/* Importing the PropTypes module from the prop-types package. */
import PropTypes from 'prop-types';

/* Importing the components from the material-ui library. */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

/* Defining the propTypes for the FormHelpDialog component. */
FormHelpDialog.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  valueSet: PropTypes.object,
};

export default function FormHelpDialog(props) {
  /* Destructuring the props object and assigning the isEdit property to a variable of the same name. */
  const { isOpen, setIsOpen, valueSet } = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle>
          <Stack direction="column">
            {valueSet?.title || 'No Help Available'}
            {valueSet?.definingURL && <Typography variant="caption">{valueSet.definingURL}</Typography>}
          </Stack>
        </DialogTitle>
        <DialogContent>
          {valueSet?.definition && (
            <Typography variant="body2" paragraph>
              {valueSet.definition}
            </Typography>
          )}
          {valueSet ? (
            <>
              <Typography>{valueSet.description}</Typography>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Display</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {valueSet.values.map((value) => (
                      <TableRow key={value.display}>
                        <TableCell>{value.display}</TableCell>
                        <TableCell>{value.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography>No help available for this field.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
